import Button from "./Button";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";

function Layout({ children, containerRef, onChange }) {
	const [activeTab, setActiveTab] = useState(0);
	
	// Validate children
	const tabs = React.Children.map(children, (child) => {
		if (child.type !== Button) {
			throw new Error(
				`Invalid child component in Layout. Expected <Button />, but received ${child.type?.name || child.type
				}.`
			);
		}

		return child.props.renderComponent;
	});

	const onTabChange = (index) => {
		setActiveTab(index);
	};

	// Trigger a rerender when containerRef updates
	const [forceUpdate, setForceUpdate] = useState(0);
	useEffect(() => {
		if (containerRef?.current) {
			setForceUpdate((prev) => prev + 1);
		}
	}, [containerRef]);

	useEffect(() => {
		onChange?.(activeTab);
	}, [activeTab]);

	return (
		<div className="flex gap-2">
			{React.Children.map(children, (child, index) =>
				React.cloneElement(child, {
					onClickHandler: () => onTabChange(index, child),
					key: index,
					isActive: activeTab === index,
				})
			)}

			{
				containerRef?.current &&
				createPortal(
					tabs[activeTab],
					containerRef.current
				)
			}
		</div>
	);
}

export default Layout;